import * as Sentry from '@sentry/browser';
import fetchPatientInformation from '../../ssr/Booking/data/fetchPatientInformation-shared';
import patientSelector from '../selectors/PatientSelector';
import { redirectOnErrorResponse } from '../utils';

export const PatientActions = { PATIENT_RETRIEVED: '@@patient/RETRIEVED' };

function fetchCurrentPatient() {
    return fetchPatientInformation({
        fetchFunc: (url) =>
            fetch(url, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                },
                credentials: 'include',
            }),
    });
}

let isFetching = false;
export function initializeCurrentPatient() {
    return async (dispatch, getState) => {
        const { patientId } = patientSelector(getState());
        if (patientId || isFetching) {
            return Promise.resolve();
        }
        isFetching = true;
        try {
            const body = await fetchCurrentPatient();
            isFetching = false;
            dispatch({
                type: PatientActions.PATIENT_RETRIEVED,
                payload: body,
            });
        } catch (exception) {
            isFetching = false;
            handleException(dispatch, exception);
        }
    };
}

function handleException(dispatch, exception) {
    // this breaks a ton in production according to sentry.  lets try and see why.
    if (exception == null) {
        Sentry.captureException(
            new Error('handleException in PatientActions had no exception?')
        );
        return;
    } else if (!exception.response) {
        Sentry.captureException(exception);
        return;
    }
    redirectOnErrorResponse(dispatch, {
        responseStatus: exception.response.status,
    });
}
